import { accountTypes } from "./account.types";

//  1. DASHBOARD LIST ACCOUNT ACTION CREATOR
export const updateAccountList = (accountList) => ({
  type: accountTypes.LIST_ACCOUNT,
  payload: accountList,
});
